import { SectorTypeLabel } from './sector-type';
import { QuesionnaireProductTypeMapping } from './product-type';
import { CompanyTypeLabel, CompanyTypeLabelQuestionnaireId } from './company-type';

const generateAnswer = (id, value, key) => ({
  answerOptions: [{ id, value }],
  questionKey: key,
});

export const getAnswerByType = (type, value) => {
  switch (type) {
    case 'amount':
      return generateAnswer(1, value, 'fundingInfo');
    case 'sector':
      return generateAnswer(+value, SectorTypeLabel[value], 'sector');
    case 'companyNumber':
      return generateAnswer(1, value, 'companyInfo');
    case 'term':
      return generateAnswer(2, value, 'fundingPeriod');
    case 'purpose':
      return generateAnswer(value.id, value.value, 'useOfFunds');
    case 'product':
      return QuesionnaireProductTypeMapping[value]
        ? generateAnswer(1, 'Yes', QuesionnaireProductTypeMapping[value])
        : null;
    case 'companyType':
      return generateAnswer(
        CompanyTypeLabelQuestionnaireId[value],
        CompanyTypeLabel[value],
        'companyType',
      );
    case 'companyName':
      return generateAnswer(1, value, 'companyName');
    default:
      return null;
  }
};
